import { auth } from "@/store/auth";
import { category } from "@/store/category";
import { company } from "@/store/company";
import { company_image } from "@/store/company_image";
import { contractor } from "@/store/contractor";
import { cost } from "@/store/cost";
import { cost_index } from "@/store/cost_index";
import csv from "@/store/csv";
import pdf from "@/store/pdf";
import { error } from "@/store/error";
import { image } from "@/store/image";
import { login } from "@/store/login";
import { partner } from "@/store/partner";
import { site } from "@/store/site";
import { staff } from "@/store/staff";
import { stage } from "@/store/stage";
import { user } from "@/store/user";
import { RootState } from "@/types";
import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0",
    loadingCount: 0
  },
  mutations: {
    loadingError: state => {
      state.loadingCount = 0;
    },
    loadingIncrement: state => {
      state.loadingCount++;
    },
    loadingDecrement: state => {
      state.loadingCount--;
    }
  },
  actions: {},
  getters: {
    isLoading: state => state.loadingCount > 0
  },
  modules: {
    auth,
    category,
    company,
    company_image,
    contractor,
    cost,
    cost_index,
    csv,
    pdf,
    error,
    image,
    partner,
    stage,
    site,
    user,
    staff,
    login
  }
};

export default new Vuex.Store<RootState>(store);
